// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AddToList: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 12 12" enableBackground="new 0 0 12 12" xmlSpace="preserve">
<path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M10.67,0C11.4,0,12,0.6,12,1.33v9.33C12,11.4,11.4,12,10.67,12H1.33
	C0.59,12,0,11.4,0,10.67V1.33C0,0.6,0.59,0,1.33,0L10.67,0z M6.67,2.67H5.33v2.67H2.67v1.33h2.67v2.67h1.33V6.67h2.67V5.33H6.67
	V2.67z"/>
</svg>;
};

export default React.memo(AddToList);
